import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { offersAction } from 'store';
import { selectHotOfferById } from 'store/offers/selector';
import { RequestsPageLayout } from 'Layout/RequestsPageLayout';
import { Images } from 'assets/images';
import { Suggestions } from 'containers/Requests/fragments/Suggestions';
import {
  RequestItemWrapper,
  InfoSection,
  InfoWrapper,
  MessageInfoImage,
  OfferImg,
  OfferInfo,
  StyledTitle,
  FlexContainer,
  TitleAndPrice,
  StarsImg,
  StyledPrice,
  CardText,
  Description,
  SampleSpan,
  SampleParagraph,
  SampleAnotherPage,
} from './styled';

export const RequestItem = () => {
  const hotOffer = useSelector(selectHotOfferById);
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(offersAction.getHotOffer(id));
  }, [dispatch]);

  return (
    <RequestsPageLayout>
      <RequestItemWrapper>
        <InfoSection>
          <InfoWrapper>
            <MessageInfoImage>
              <OfferImg src={hotOffer?.main_image} alt="icon" />
            </MessageInfoImage>

            <OfferInfo isRequest>
              <StyledTitle>{hotOffer?.title}</StyledTitle>
              <TitleAndPrice>
                <FlexContainer>
                  <StarsImg src={Images.stars} alt="stars" />
                </FlexContainer>
              </TitleAndPrice>
              <StyledPrice>$ {hotOffer?.price}</StyledPrice>

              <CardText>
                <Description
                  dangerouslySetInnerHTML={{
                    __html: ['<span>Description: </span>' + hotOffer?.description],
                  }}
                />
              </CardText>

              <CardText>
                <SampleParagraph>Country, City:</SampleParagraph>
                <span>
                  {hotOffer?.country?.name}, {hotOffer?.city?.name}
                </span>
              </CardText>

              <CardText>
                <SampleParagraph>Population:</SampleParagraph>
                <span>{hotOffer?.population}</span>
              </CardText>

              <CardText>
                <SampleParagraph>Language: </SampleParagraph>
                <span>{hotOffer?.language}</span>
              </CardText>

              <CardText>
                <SampleParagraph>Booking URL: </SampleParagraph>
                <SampleSpan>
                  <SampleAnotherPage
                    href={hotOffer?.booking_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {hotOffer?.booking_url}
                  </SampleAnotherPage>
                </SampleSpan>
              </CardText>

              <CardText>
                <SampleParagraph>Ticket URL:</SampleParagraph>
                <SampleSpan>
                  <SampleAnotherPage
                    href={hotOffer?.ticket_url}
                    target="_blank"
                    rel="noreferrer"
                    key={uuid()}
                  >
                    {hotOffer?.ticket_url}
                  </SampleAnotherPage>
                </SampleSpan>
              </CardText>

              {hotOffer?.label?.map((label) => (
                <CardText key={uuid()}>
                  <SampleParagraph>{label.label_key}:</SampleParagraph>
                  <SampleSpan>
                    <SampleAnotherPage
                      href={label.label_value}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {label.label_value}
                    </SampleAnotherPage>
                  </SampleSpan>
                </CardText>
              ))}
            </OfferInfo>
          </InfoWrapper>
        </InfoSection>
        {hotOffer?.suggestions?.length > 0 ? (
          <Suggestions suggestions={hotOffer.suggestions} />
        ) : null}
      </RequestItemWrapper>
    </RequestsPageLayout>
  );
};
